import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-white font-bold text-xl mb-4">MPillar</h3>
            <p className="text-sm">Helping businesses grow through smart customer engagement solutions.</p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Product</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#features" className="hover:text-orange-500">Features</a></li>
              <li><a href="#pricing" className="hover:text-orange-500">Pricing</a></li>
              <li><a href="#testimonials" className="hover:text-orange-500">Testimonials</a></li>
              <li><a href="#faq" className="hover:text-orange-500">FAQ</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Support</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="mailto:support@mpillar.com" className="hover:text-orange-500">Email Support</a></li>
              <li><a href="#" className="hover:text-orange-500">Setup Guide</a></li>
              <li><a href="#" className="hover:text-orange-500">Video Tutorials</a></li>
              <li><a href="#" className="hover:text-orange-500">Contact Us</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="hover:text-orange-500">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-orange-500">Terms of Service</a></li>
              <li><a href="#" className="hover:text-orange-500">Refund Policy</a></li>
              <li><a href="#" className="hover:text-orange-500">Shipping Policy</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm mb-4 md:mb-0">
              &copy; 2025 MPillar. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <span className="text-sm">Trusted by 500+ businesses across India</span>
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <span key={i} className="text-yellow-400">★</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;